class AjaxPagination {
  constructor() {
    this.container = document.getElementById('ProductGridContainer');
    if (!this.container) return;

    this.loading = false;

    // Intercept pagination link clicks via event delegation
    this.container.addEventListener('click', this.onLinkClick.bind(this));

    // Handle browser back/forward
    window.addEventListener('popstate', this.onPopState.bind(this));

    // Save current state so popstate works on first back
    history.replaceState({ url: window.location.href }, '');
  }

  onLinkClick(event) {
    const link = event.target.closest('a.pagination__item');
    if (!link) return;

    event.preventDefault();
    if (this.loading) return;

    this.fetchPage(link.href, true);
  }

  onPopState(event) {
    if (event.state && event.state.url) {
      this.fetchPage(event.state.url, false);
    }
  }

  fetchPage(url, pushState) {
    this.loading = true;

    const grid = document.getElementById('product-grid');
    const paginationWrapper = this.container.querySelector('.pagination-wrapper');

    if (grid) grid.style.opacity = '0.4';
    if (paginationWrapper) paginationWrapper.style.pointerEvents = 'none';

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newContainer = doc.getElementById('ProductGridContainer');
        if (!newContainer) return;

        // Replace product grid
        const newGrid = doc.getElementById('product-grid');
        const currentGrid = document.getElementById('product-grid');
        if (newGrid && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
          currentGrid.style.opacity = '';
        }

        // Replace pagination
        const newPagination = newContainer.querySelector('.pagination-wrapper');
        const currentPagination = this.container.querySelector('.pagination-wrapper');
        if (newPagination && currentPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
          currentPagination.style.pointerEvents = '';
        } else if (!newPagination && currentPagination) {
          currentPagination.remove();
        }

        // Update browser URL
        if (pushState) {
          history.pushState({ url }, '', url);
        }

        // Scroll to top of the grid (with offset for sticky header)
        const top = this.container.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      })
      .catch(error => {
        console.error('[AjaxPagination]', error);
        if (grid) grid.style.opacity = '';
        if (paginationWrapper) paginationWrapper.style.pointerEvents = '';
      })
      .finally(() => {
        this.loading = false;
      });
  }
}

document.addEventListener('DOMContentLoaded', () => new AjaxPagination());
